import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/group/importer/groupImporterActions';

export default importerReducers(actions);
